import { yupResolver } from '@hookform/resolvers/yup';
import { SubmitHandler, useForm } from 'react-hook-form';
import * as yup from 'yup';

import { useCreatePlaceMutation } from '../../../../hooks/useCreatePlaceMutation';
import { PlaceFormInputs } from '../PlaceForm/PlaceForm';

const schema = yup
  .object({
    name: yup.string().required('Le nom du lieu est requis'),
    address: yup.string().required("L'adresse du lieu est requise"),
  })
  .required();

export const useCreatePlaceDrawer = (
  onClose: (createdPlaceId: string) => void,
) => {
  const { createPlace } = useCreatePlaceMutation(onClose);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<PlaceFormInputs>({
    resolver: yupResolver(schema),
  });

  const onValid: SubmitHandler<PlaceFormInputs> = async (data) => {
    createPlace(data);
  };
  const onSubmit = handleSubmit(onValid);

  return {
    register,
    errors,
    onSubmit,
  };
};
